import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'formatRawTime',
    pure: true
})

    // Time is received as 03:30 PM -> 15:30 || 11:30 AM -> 11:30

export class RawTimePipe implements PipeTransform {
    constructor(private _datePipe: DatePipe) { }
    transform(formattedTime: string): string {
        try {
            let timeWithoutIndicator = formattedTime.substring(0, formattedTime.length - 3);
            let rawTimeSplitted = timeWithoutIndicator.substring(0, formattedTime.length - 3).split(':');

            if (formattedTime.includes('PM') || formattedTime.includes('pm')) {
                if (parseInt(rawTimeSplitted[0]) < 12) {
                    return `${parseInt(rawTimeSplitted[0]) + 12}:${rawTimeSplitted[1]}`;
                } else {
                    return `${parseInt(rawTimeSplitted[0])}:${rawTimeSplitted[1]}`;
                }
            } else {
                return timeWithoutIndicator;
            }
        } catch (e) {
            console.log('Error formatting time:' + e);
        }
    }
}